import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    create: Boolean,
    placeholder: String
  }

  connect() {
    if (this.element.tomselect) return

    const render = {
      no_results: () => '<div class="no-results">該当なし</div>'
    }

    if (this.createValue) {
      render.option_create = (data, escape) => {
        return `<div class="create">「${escape(data.input)}」を追加</div>`
      }
    }

    this.tomSelect = new TomSelect(this.element, {
      allowEmptyOption: true,
      create: this.createValue ? this.createOption : false,
      createOnBlur: this.createValue,
      persist: true,
      placeholder: this.placeholderValue || this.element.getAttribute("placeholder") || "検索",
      sortField: [{ field: "$order" }],
      render
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }

  createOption(input) {
    const value = input.trim()
    if (!value) return false

    return { value, text: value }
  }
}
